import { ManagerUrlParamsFilter } from '../../../entities/filters/manager-url-params-filter';
import { DateUrlParamsFilter } from '../../../entities/filters/date-url-params-filter';
import { LeadStatusParamFilter } from './lead-status-param-filter';
import { FilterWrapper, ValueFormatterContext } from '../../../shared/ui/filter/filter-wrapper';
import { Stack } from '@mui/material';
import { useLeadStatuses } from 'entities/lead/lead-status/lead-status.hook';
import { useManagersDropdownList } from 'features/user/user-picker/ui';
import { LeadSourceFilter } from './lead-source-filter';
import { leadSourceChoicesApi } from 'entities/lead/lead-source-choices.api';
import { LEAD_SOURCE_LABELS, LeadSourceType } from '@sr/dto';

export const LeadsFilter = () => {
  const { data: sources = [] } = leadSourceChoicesApi.useGetLeadSourceChoicesQuery();
  const statuses = useLeadStatuses();
  const { items: managers } = useManagersDropdownList();

  const statusFormatter = ({ value }: ValueFormatterContext) => {
    const option = statuses.items.find((item) => String(item.id) === value);
    return option ? option.label : value;
  };

  const managerValueFormatter = ({ value }: ValueFormatterContext) => {
    const manager = managers.find((m) => String(m.id) === value);
    return manager ? `${manager.firstName} ${manager.secondName || ''}`.trim() : value;
  };

  return (
    <FilterWrapper title="Фильтры лидов">
      <FilterWrapper.Item label="Статусы" queryKeys="statusId" valueFormatter={statusFormatter}>
        <LeadStatusParamFilter queryParamName="statusId" customSize={5} multi label="Статус" />
      </FilterWrapper.Item>

      <FilterWrapper.Item label="Менеджер" queryKeys="managerId" valueFormatter={managerValueFormatter}>
        <ManagerUrlParamsFilter queryParamName="managerId" withNonSelect />
      </FilterWrapper.Item>

      <FilterWrapper.Item label="Источник" queryKeys={['sourceType', 'source2Id']} summaryFormatter={({ searchParams }) => {
        const type = searchParams.get('sourceType');
        const id = searchParams.get('source2Id');
        const source = sources.find((item) => String(item.id) === id && (!type || item.sourceType === type));
        const labels = [type ? LEAD_SOURCE_LABELS[type as LeadSourceType] || type : '', source?.source2Name || (id ? `Источник № ${id}` : '')].filter(Boolean);
        return labels.length ? `Источник: ${labels.join(' / ')}` : 'Источник';
      }}>
        <LeadSourceFilter />
      </FilterWrapper.Item>

      <FilterWrapper.Item
        label="Создан"
        queryKeys={['fromDate', 'toDate']}
        summaryFormatter={({ searchParams }) => {
          const fromDate = searchParams.get('fromDate');
          const toDate = searchParams.get('toDate');
          if (!fromDate && !toDate) return 'Создан';
          if (fromDate && toDate) return `Создан: ${fromDate} — ${toDate}`;
          return `Создан: ${fromDate || toDate}`;
        }}
      >
        <Stack spacing={1.5}>
          <DateUrlParamsFilter queryParamName="fromDate" label="Создан с" size="small" />
          <DateUrlParamsFilter queryParamName="toDate" label="Создан по" size="small" />
        </Stack>
      </FilterWrapper.Item>
    </FilterWrapper>
  );
};
